import { membershipState } from '@/store/modules/MembershipState'
import axios, { AxiosResponse } from 'axios'
import PathUtil from '@/modules/PathUtil'
import Drupal from '@/modules/Drupal'

/**
 * APIリクエスト共通処理
 * 正常に処理が終了した際は呼び出し元にレスポンス内容を返却する
 * エラーが返ってきたときは onErrorを実行する
 * @param path APIリクエストパス
 * @param data POSTする際にサーバ側に渡すデータ
 * @param sysErrorFlg システムエラー画面に遷移させるか否か
 *  false: 遷移しない, true: 遷移する
 */
export const post = async (path: string, data?: any, sysErrorFlg = true): Promise<AxiosResponse> => {
  if (!data) data = {}
  return await axios.post(PathUtil.makePath(path), data)
    .then((res: AxiosResponse) => onNomal(res))
    .catch(err => onError(err, sysErrorFlg))
}

/**
 * APIリクエスト正常処理
 */
const onNomal = (res: any):any => {
  if (res.data.result === 'session_error') {
    // sessionエラーのとき：システムエラー画面に遷移
    window.location.href = Drupal.member.pageUrl.sessionError
  } else {
    return res
  }
}
/**
 * APIリクエストエラー処理
 */
const onError = (err: any, sysErrorFlg: boolean): any => {
  // リクエストが中断されたとき
  if (err.message === 'Request aborted') {
    return err.request
  }
  if (err.response === undefined && sysErrorFlg) {
    // レスポンスなし：システムエラー画面に遷移
    window.location.href = Drupal.member.pageUrl.systemError
    return err
  } else if (err.response.status === 403) {
    // 未認証：現在のページに再アクセス(サーバー側のフィルターを利用しログインモーダルを表示)
    const currentPath = window.location.pathname
    window.location.href = currentPath
  } else if (err.response.status === 404) {
    // APIが存在しない場合： 何もしない
    return err.response
  } else if (sysErrorFlg) {
    // 403以外のエラー：システムエラー画面に遷移
    window.location.href = Drupal.member.pageUrl.systemError
  }
  return err.response
}
